import "../css/style.scss"

console.log('It works. (My tribute to Wes Bos :) )')
const prevURL = document.referrer
console.log(prevURL)

window.toggleMobileNav = function() {
    var x = document.getElementById("nav-main");
    if (x.classList.contains('navhidden')) {
        x.classList.remove('navhidden')
    } else {
        x.classList.add('navhidden')
    }
}

import Search from "./modules/Search"

const search = new Search()
